import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 3,
  class: "maintenance-checking"
}
const _hoisted_2 = {
  key: 4,
  class: "maintenance-checking"
}
const _hoisted_3 = {
  key: 5,
  class: "maintenance-test-banner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MaintenanceScreen = _resolveComponent("MaintenanceScreen")!
  const _component_MaintenanceTesterLogin = _resolveComponent("MaintenanceTesterLogin")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_config_provider, { locale: _ctx.locale }, {
      default: _withCtx(() => [
        (_ctx.maintenanceReady && _ctx.maintenanceConfig.enabled && !_ctx.testerAllowed && !_ctx.testerLogin && !_ctx.testerRefreshing)
          ? (_openBlock(), _createBlock(_component_MaintenanceScreen, {
              key: 0,
              config: _ctx.maintenanceConfig,
              checking: _ctx.maintenanceChecking,
              onRefresh: _ctx.refreshMaintenance,
              onTester: _ctx.beginTesterLogin
            }, null, 8, ["config", "checking", "onRefresh", "onTester"]))
          : (_ctx.maintenanceReady && _ctx.maintenanceConfig.enabled && _ctx.testerLogin && !_ctx.testerAllowed)
            ? (_openBlock(), _createBlock(_component_MaintenanceTesterLogin, {
                key: 1,
                onAuthenticated: _ctx.verifyTesterLogin,
                onCancel: _ctx.exitMaintenanceTest
              }, null, 8, ["onAuthenticated", "onCancel"]))
            : (_ctx.maintenanceReady && _ctx.applicationReady && (!_ctx.maintenanceConfig.enabled || _ctx.testerAllowed || _ctx.testerRetaining))
              ? _withDirectives((_openBlock(), _createBlock(_component_router_view, { key: 2 }, null, 512)), [
                  [_vShow, !_ctx.maintenanceConfig.enabled || _ctx.testerAllowed]
                ])
              : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.maintenanceError ? '暂时无法确认系统状态，请稍后重试。' : _ctx.applicationError ? '页面加载失败，请稍后重试。' : _ctx.maintenanceReady ? '正在加载页面...' : '正在检查系统状态...'), 1),
                  (_ctx.maintenanceError || _ctx.applicationError)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        loading: _ctx.maintenanceChecking || _ctx.applicationChecking,
                        onClick: _ctx.refreshMaintenance
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("重试")
                        ]),
                        _: 1
                      }, 8, ["loading", "onClick"]))
                    : _createCommentVNode("", true)
                ])),
        (_ctx.testerRetaining && !_ctx.testerAllowed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "正在验证维护测试资格..."))
          : _createCommentVNode("", true),
        (_ctx.testerAllowed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createTextVNode("维护测试中 "),
              _createVNode(_component_a_button, {
                size: "small",
                onClick: _ctx.exitMaintenanceTest
              }, {
                default: _withCtx(() => [
                  _createTextVNode("退出维护测试")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["locale"])
  ]))
}